@if (title) {
  <div>
    @if (sampleForm) {
      <form [formGroup]="sampleForm" (ngSubmit)="onSubmit()">
        <mat-card>
          <mat-card-header
            ><mat-card-title>{{ title }}</mat-card-title></mat-card-header
            >
            <mat-card-content>
              @for (info of informations; track info) {
                <div class="row flex">
                  <div class="col flex-50">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>{{ info['display_' + locale] }}</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="{{ info.fieldName }}"
                        />
                    </mat-form-field>
                  </div>
                  @if (helptexts) {
                    <div class="helptext flex-50 col">
                      <mat-icon class="material-icons">info_outlined</mat-icon>
                      <div [innerHtml]="helptexts[info.fieldName]"></div>
                    </div>
                  }
                </div>
              }
              <div class="row" formArrayName="points">
                <mat-card-title style="font-size: medium"><p
                  i18n="measurement points@@measurement_points">Measurement points
          </p>
                <mat-card-actions>
                  <button mat-flat-button color="primary" (click)="addPoint()" i18n="add measurement point caps@@add_measurement_point">
                ADD MEASUREMENT POINT
              </button>
                  @if (qualityType && qualityEndpoint) {
                    <button mat-flat-button color="accent" (click)="copyFromYear()" [disabled]="isLoadingYears" style="margin-left: 8px">
                      COPY FROM OTHER YEAR
                    </button>
                  }
                </mat-card-actions>
              </mat-card-title>
              @for (point of points.controls; track point; let i = $index) {
                <div>
                  <div [formGroupName]="i" class="measurement-point-row">
                    <mat-form-field appearance="fill">
                      <mat-label i18n="latitude@@latitude">Latitude</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="latitude"
                        />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label i18n="longitude@@longitude">Longitude</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="longitude"
                        />
                    </mat-form-field>
                    <button mat-flat-button color="warn" (click)="deletePoint(i)" i18n="delete@@delete">
                Delete
              </button>
                  </div>
                </div>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </form>
    }
  </div>
}
